/**************************************************
 * Nombre:       Tarjeta_Categoria
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import tmp_categoria from '../../Recursos/Temporales/tmp_categoria.png'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjeta_Categoria = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: theme.palette.primary.main,
                borderRadius: 2,
                p: sCell ? 1 : 1.5,
                cursor: 'pointer',
                transition: 'all 0.2s ease-in-out',
                "&:hover": {
                    scale: 1.04
                }
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{
                    width: '100%',
                    background: theme.palette.primary.main,
                    color: '#fff',
                    fontWeight: 400,
                    fontSize: 14,
                    textAlign: 'center',
                    mt: -0.5,
                    lineHeight: 1.2,
                }}>{'GAFAS PARA HOMBRE'}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0.6}}>
                <img src={tmp_categoria} width={'100%'} height={'auto'} style={{borderRadius: 6}} />
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Categoria